import React from "react";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";

/*
	 Generic read-only version of a player component 
 */
class PlayerItemValueReadOnly extends React.PureComponent {

	render() {
		const { item, getImage, getVideo, getPdf } = this.props;


		let label = item.value;
		if (this.props.label) {
			label = this.props.label;
		}

		if (item.pickerItems && (item.hasOwnProperty("x_pickerItemsDatasource") || item.hasOwnProperty("pickerItemsDatasource"))) {
			let valueKey = "value";
			let labelKeys = ["label"];
			const dsDefinition = item.hasOwnProperty("x_pickerItemsDatasource") ? item["x_pickerItemsDatasource"] : item["pickerItemsDatasource"];
			valueKey = _.first(dsDefinition.valueKeys);
			labelKeys = dsDefinition.labelKeys;
			const items = item.pickerItems;
			const { value } = item;
			for (let i = 0; i < items.length; i++) {
				const _item = items[i];
				if (_item[valueKey] === value) {
					let _label = [];
					labelKeys.forEach(lk => {
						_label.push(_item[lk]);
					});
					label = _label.join(" ");
				}
			}
		}

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();

		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div>
						{label}
					</div>
				</div>
			</div>
		);
	}
}

export default withPlayerItemHoc(PlayerItemValueReadOnly);